import React from "react";

import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";

import { TaskListView } from "components/FormTasksView/List";
import styles from "components/FormTasksView/styles.css";
import { PROJECTS, PROJECTS_BASE_ROUTE } from "globals/constants";

const ProjectTasksView = ({ projectId }) => {
	if (!projectId) {
		return (
			<div id="view-main-task" className={styles.viewMainTask}>
				<LoadingIndicator />
			</div>
		);
	}

	function getTaskPagePath (id, taskType) {
		let formType = id ?? "create";

		return `/sp${PROJECTS_BASE_ROUTE}/${projectId}/${taskType}/${formType}`;
	}

	return (
		<div id="view-main-task" className={styles.viewMainTask}>
			<TaskListView
				instanceId={projectId}
				tasksFor={PROJECTS}
				getTaskPagePath={getTaskPagePath}
			/>
		</div>
	);
};

export default ProjectTasksView;
